import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Translate from '../Translate/Translate.js';

import { IMorningStarConfiguration, IMorningStarProps, IMorningStarState } from './models/index.js';
import MorningStarIcon from './styledComponents/MorningStarIcon.js';
import MorningStarIconWrapper from './styledComponents/MorningStarIconWrapper.js';
import Wrapper from './styledComponents/Wrapper.js';
import { MORNING_STAR_CATEGORY_KEY, MORNING_STAR_COMPONENT_KEY } from './MorningStar.meta.js';

export class MorningStar extends ComponentBase<IMorningStarProps, IMorningStarState, IMorningStarConfiguration> {
	categoryKey = MORNING_STAR_CATEGORY_KEY;
	componentKey = MORNING_STAR_COMPONENT_KEY;

	constructor(props: IMorningStarProps) {
		super(props);

		makeObservable(this, {
			morningStars: computed,
		});
	}

	get morningStars() {
		let { morningStarRating } = this.props;
		if (morningStarRating && !common.commonUtils.isNumber(morningStarRating)) {
			morningStarRating = parseInt(morningStarRating, 10);
			if (Number.isNaN(morningStarRating)) {
				morningStarRating = 0;
			}
		}
		const { noRatingPlaceholderText } = this.props;
		if (!morningStarRating) {
			if (noRatingPlaceholderText) {
				return <Translate>{noRatingPlaceholderText}</Translate>;
			}
			return null;
		}
		const maxStarRating = 5;
		if (morningStarRating > maxStarRating) {
			morningStarRating = maxStarRating;
		}
		const stars = [];
		for (let i = 0; i < morningStarRating; i++) {
			stars.push(
				<MorningStarIconWrapper key={`star_${i}`} aria-hidden={true}>
					<MorningStarIcon />
				</MorningStarIconWrapper>,
			);
		}
		return stars;
	}
	render() {
		const { className, morningStarRating } = this.props;
		return (
			<Wrapper className={className} role="img" aria-label={`${morningStarRating}`}>
				{this.morningStars}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(MorningStar), MORNING_STAR_CATEGORY_KEY, MORNING_STAR_COMPONENT_KEY);
